import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { usePendingApprovalRequestWarningDialog } from "./usePendingApprovalRequestWarningDialog"
import { useLocalStorageTtl } from "@/utils/localStorageTtl"
import { usePendingApprovalRequestExistsToday } from "@/hooks/useApprovalRequest"

// 再度、清掃一覧に来た時に未承認の承認リクエストの存在を警告するかどうかの時間間隔
const dialogReopenDurationMs = 1000 * 60

const localStorageKey = "PendingApprovalRequestWarningDialogKey"
const localStorageValue = "t"

/**
 * 未承認の承認リクエストが存在する場合に、警告ダイアログを表示する
 * 一度表示した後は、一定時間間隔を空けて再度表示する
 */
export const usePendingApprovalRequestWarningControl = () => {
    const navigate = useNavigate()
    const { openModal: openPendingApprovalRequestWarningDialog, closeModal } =
        usePendingApprovalRequestWarningDialog({
            onClick: () => {
                closeModal()
                navigate("/approval_requests")
            }
        })

    const { data: pendingApprovalRequestExists } =
        usePendingApprovalRequestExistsToday()
    const { value: recentlyOpened, setValue: setRecentlyOpened } =
        useLocalStorageTtl(localStorageKey, dialogReopenDurationMs)

    useEffect(() => {
        ;(async () => {
            if (pendingApprovalRequestExists?.exists && !recentlyOpened) {
                openPendingApprovalRequestWarningDialog()
                setRecentlyOpened(localStorageValue)
            }
        })()
    }, [
        openPendingApprovalRequestWarningDialog,
        pendingApprovalRequestExists,
        recentlyOpened,
        setRecentlyOpened
    ])
}
